<template>

	<div class="panel panel-clinic">

		<div class="panel-heading collapsed" href="#form_connection_internal" data-toggle="collapse">

			<div class="arrow-down"></div>

			<h2 class="panel-title">Anslutning mottagningsmassör</h2>

		</div>

		<div id="form_connection_internal" class="panel-collapse collapse">

			<div class="panel-body">

				<div class="form-horizontal">
					<div class="form-group oddevencol">
						<label class="col-md-14 control-label">Skickat välkomstmail (via systemet)</label>
						<div class="col-md-36">
							<p>{{ clinic.contract_internal_sent }}</p>
						</div>
					</div>
					<div class="form-group oddevencol">
						<label class="col-md-14 control-label">Skickat demokort (via systemet)</label>
						<div class="col-md-36">
							<p>{{ clinic.demo_card_sent }}</p>
						</div>
					</div>
					<row-meta
						:clinic-id="clinic.id"
						:row-meta="meta"
						:showForced="true"
						:showDate="true"
						:showComment="true"
						type="checkbox_letter_sent"
						layout="checkBox"
						title="Skickat startkit">
					</row-meta>
				</div>

				<div class="form-horizontal">
					<row-meta
						:clinic-id="clinic.id"
						:row-meta="meta"
						:showForced="true"
						:showDate="true"
						:showComment="true"
						type="checkbox_booking"
						layout="checkBox"
						title="Bokningsförfarande ok"
						comment="Är våra tjänster upplagda i nätbaserad kalender? Eller finns annat bokningsförfarande definierat för våra kunder?">
					</row-meta>
				</div>

				<div class="form-horizontal">

					<div class="row row-meta oddevencol validateRule approvedIntExt" v-bind:class="{ complete: validateRule('rule_reconciliation') }">
						<div class="col-md-50 control-label first withcomm">
							<label style="font-weight:normal;">Godkänd avstämning med mottagningsmassör</label>
						</div>
					</div>

					<row-meta
						:clinic-id="clinic.id"
						:row-meta="meta"
						:showForced="true"
						:showDate="true"
						:showComment="true"
						type="checkbox_reconciliation_payment_account"
						layout="checkBox"
						title="Har massören lagt in sina bankuppgifter?">
					</row-meta>

					<row-meta
						:clinic-id="clinic.id"
						:row-meta="meta"
						:showForced="true"
						:showDate="true"
						:showComment="true"
						type="checkbox_reconciliation_signature"
						layout="checkBox"
						title="Har massören provat sin signatur i demokortet?">
					</row-meta>

					<row-meta
						:clinic-id="clinic.id"
						:row-meta="meta"
						:showForced="true"
						:showDate="true"
						:showComment="true"
						type="checkbox_reconciliation_recover_card"
						layout="checkBox"
						title='Har ni gått igenom de viktigaste delarna i avtalet samt bilagan?'>
					</row-meta>

					<row-meta
						:clinic-id="clinic.id"
						:row-meta="meta"
						:showForced="true"
						:showDate="true"
						:showComment="true"
						type="checkbox_reconciliation_deviation"
						layout="checkBox"
						title="Vet massören hur hen ska skicka in en manuell registrering?">
					</row-meta>
				</div>

				<div class="form-horizontal">

					<div class="row row-meta oddevencol validateRule approvedIntExt" v-bind:class="{ complete: clinic.is_public }">
						<div class="col-md-50 control-label first withcomm">
							<label style="font-weight:normal;">Publicerad i klippkort</label>
						</div>
					</div>

					<row-meta
						:clinic-id="clinic.id"
						:row-meta="meta"
						:extra-data="admins"
						:showDate="true"
						type="select_region_manager"
						layout="selectMenuArray"
						title="Överlämning till regionansvarig">
					</row-meta>

					<div class="form-group oddevencol" v-if="meta.select_region_manager && meta.select_region_manager.value">
						<label class="col-md-14 control-label">Maila regionansvarig</label>
						<div class="col-md-36">
							<div class="btn btn-default" v-on:click="notifyRegionManager()">Skicka mail</div>
						</div>
					</div>

				</div>

			</div>

		</div>

	</div>

</template>

<script>

import mixin from './mixin'

export default {

    	mixins: [mixin],

	    data () {
      		return {

      		}
	    },

	    computed: {

	    	admins () {
	    		const admins = []

	    		admins.push({

    				value: null,
    				text: 'Välj'

    			})

	    		_.forEach(_.filter(this.users, ['type', 'admin']), function (admin) {
	    			admins.push({

	    				value: admin.id,
	    				text: admin.name

	    			})
            })

            return admins
	    	},

	    	timezynkComment () {
	    		if (this.meta.text_timezynk_id.value && this.meta.text_timezynk_id.value.length != 24) {
	    			return '<b style="color: red;">Felaktigt TimeZynk ID!</b>'
	    		}
	    	}

	    },

	    methods: {

	    	notifyRegionManager () {
	    		const self = this
	    		self.$http.post('/clinics/notifyRegionManager', { clinic_id: self.clinic.id }).then((response) => {
                console.log(response.body)
                   	bus.$emit('notify', 'Mail skickat till regionansvarig.')
            }, (response) => {
                console.log(JSON.stringify(response))
            })
	    	},
	    	notifyContactManager () {
	    		const self = this
	    		self.$http.post('/clinics/notifyContactManager', { clinic_id: self.clinic.id }).then((response) => {
                console.log(response.body)
                   	bus.$emit('notify', 'Mail skickat till kontaktansvarig.')
            }, (response) => {
                console.log(JSON.stringify(response))
            })
	    	}

	    }

}

</script>
